import Axios from 'axios';
import { DataResponse, PromotionInfo } from '../models';

export const getActivePromotionCampaign = async (accountId: number) => (
  await Axios.get<DataResponse<PromotionInfo>>(`/v1/commerce/promotion-campaigns/${accountId}/active`, {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
).data.data;
